import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import usersReducer from "./ducks/users";
import orchestratorReducer from "./ducks/orchestrator";
import authReducer from "./ducks/auth";
import analyticsReducer from "./ducks/analytics";
import cartReducer from "./ducks/cart";
import actionItemsReducer from "./ducks/actionItems";
import chatReducer from "./ducks/chat";
import notificationReducer from "./ducks/notifications";
import layoutReducer from "./ducks/layout";
import klarnaReducer from "./ducks/klarna";
import collectJSReducer from "./ducks/collectjs";
import funnelReducer from "./ducks/funnel";
import communitiesReducer from "./ducks/communities";
import digitalWalletsReducer from "./ducks/digitalWallets";
import supportReducer from "./ducks/support";
import automationsReducer from "./ducks/automations";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
    authState: authReducer,
    analyticsState: analyticsReducer,
    users: usersReducer,
    orchestrator: orchestratorReducer,
    cartState: cartReducer,
    actionItemsState: actionItemsReducer,
    chatState: chatReducer,
    notificationState: notificationReducer,
    layoutState: layoutReducer,
    klarnaState: klarnaReducer,
    collectJSState: collectJSReducer,
    funnelState: funnelReducer,
    communitiesState: communitiesReducer,
    digitalWalletsState: digitalWalletsReducer,
    supportState: supportReducer,
    automationsState: automationsReducer
});
const enhancer = composeEnhancers(applyMiddleware(thunk));

const store = createStore(rootReducer, enhancer);

export default store;